module.exports = __webpack_public_path__ + "static/media/8.1.3.1.yandex_alisa_muzika.7c4805e6.png";